import React, { useState, useEffect, Fragment } from 'react';
import services from '../../services';
import { validateProperty, validate } from "../../../Common"
import { AddSupplierAddEditSchemaObject } from '../../AddSupplierSchema'
import MessageModal from '../../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../../Common';
import Joi, { date } from '@hapi/joi';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import { CommonDecryptParam } from '../../../../../utils/CommonParams';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { generateStatus } from '../../satusGenerator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Grid } from '@material-ui/core';
import { AlertDialog } from '../../../../Common/AlertDialog';



const screenCode = 'PURCHASEORDER';

export function SuppliersAdd(props) {

    const [title, setTitle] = useState("Add Suppliers")
    const [supplierItems, setSupplierItems] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [filterSupplier, setFilterSupplier] = useState([]);
    const [orderDetails, setOrderDetails] = useState([]);
    const [orderItemsDetails, setOrderItemsDetails] = useState([]);
    const [orderItemsViseQty, setOrderItemsViseQty] = useState([]);
    const [itemDetails, setItemDetails] = useState([]);
    const [addSuppliers, setAddSuppliers] = useState({
        groupID: '0',
        operationEntityID: '0',
        orderID: '0',
        collectionTypeID: '0',
        customerID: '0',
        quantity: '0',
        unitPrice: '0',
        totalPrice: '',
        supplyDate: ''
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object(AddSupplierAddEditSchemaObject).options({ allowUnknown: true })
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});
    const [isOrderCompleted, setIsOrderCompleted] = useState(false);
    const [isItemRejected, setIsItemRejected] = useState(false);
    const [remainSupplyingQty, setRemainSupplyingQty] = useState(0);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [deleteItemData, setDeleteItemData] = useState(false);

    //popup
    const [message, setMessage] = useState("Email Sending Verification");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);

    const [usermessage, setUserMessage] = useState("User Add Verification");
    const [UserConfirmMessage, setUserConfirmMessage] = useState(false);



    const encriptedText = props.match.params["id"];
    const id = (encriptedText !== undefined) ? CommonDecryptParam(encriptedText) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;
    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const tableHeaderStyle = {
        color: "#263238",
        textTransform: "uppercase",
        fontSize: "12px",
        fontWeight: "bold"
    }
    const subTableHeaders = {
        textTransform: "uppercase",
        fontSize: "12px"
    }

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        checkIsOrderCompleted()
    }, [itemDetails, supplierItems]);

    useEffect(() => {
        trackPromise(
            getSuppliers()
        );
    }, [addSuppliers.operationEntityID]);

    useEffect(() => {
        if (messageModel.hidden === false) {
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 2000);
        }
    }, [messageModel])

    //popup
    async function handleEmail() {
        setEnableConfirmMessage(true);
    }
    function confirmData(y) {
        if (y) {
            onEmailSend();
        }
    }

      //UserAddpopup
      async function handleUserAdd() {
       handleAddItem();
    }
    function confirmUserData(y) {
        
        if (y) {
            checkAddUser();
        }
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDSUPPLIER');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setTitle("Edit Suppliers")
            setScreenData();
        }
    }

    async function getSuppliers() {
        const suppliersData = await services.GetSuppliersByOperationEntity(addSuppliers.operationEntityID);
        setSuppliers(suppliersData);
    }

    async function setScreenData() {
        var result = await services.getOrderDetailsForSupplierAddScreen(id);
        setOrderDetails(result.order);
        setOrderItemsDetails(result.orderItems);

        var count = 0;

        result.orderItems.forEach(x => {
            if (x.statusTypeID === 7) {
                count++;
            }
        });

        if (count > 0) {
            setIsItemRejected(true);
            generateRemainSupplyQty(result.orderItems);
        }

        var items = [];

        result.orderItems.forEach(x => {
            var supplierItems = [];

            result.supplierOrderItems.forEach(r => {
                if (r.orderItemID === x.orderItemID) {
                    supplierItems.push({
                        supplierOrderItemsID: r.supplierOrderItemsID,
                        orderItemID: r.orderItemID,
                        customerID: r.customerID,
                        supplierName: r.firstName,
                        unitPrice: r.unitPrice,
                        totalPrice: r.totalPrice,
                        supplingQauntity: r.supplingQauntity,
                        lastUnitPrice: r.lastUnitPrice,
                        rejectReason: r.rejectReason,
                        statusType: r.statusTypeID,
                        version: r.version
                    })
                }
            })

            items.push(
                createData(
                    x.orderItemID,
                    x.collectionTypeName,
                    x.collectionTypeID,
                    x.itemQuantity,
                    x.measuringUnit,
                    x.remQty.toFixed(2),
                    supplierItems
                )
            );

        });

        setItemDetails(items);
        setSupplierItems(result.supplierOrderItems);

        setAddSuppliers({
            ...addSuppliers,
            groupID: result.order.groupID,
            operationEntityID: result.order.operationEntityID,
            orderID: result.order.orderID
        });
    }

    async function generateRemainSupplyQty(orderItems) {

        var totQty = 0;
        var supQty = 0;

        orderItems.forEach(x => {
            totQty += x.itemQuantity;
        });

        var sumofRemain = await services.getRemainSupplierCount(id);
        setOrderItemsViseQty(sumofRemain.data);

        sumofRemain.data.forEach(x => {
            supQty += x.supplingQauntity;
        });

        return (totQty - supQty);
    }

    function filterSuppliers(data) {
        var newList = [];
        if (data.collectionTypeID != null) {
            newList = suppliers.filter(selects => selects.collectionTypeID == data.collectionTypeID);
            setFilterSupplier(newList);
        } else {
            setFilterSupplier([]);
        }
    }

    function sortList(data) {
        var supplierArray = [];
        for (let item of Object.entries(data)) {
            supplierArray[item[1]["customerID"]] = item[1]["firstName"] + "-" + item[1]["customerCode"];
        }
        return supplierArray;
    }

    function handleChange(e) {
        const target = e.target

        const value = target.name === 'isActive' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, AddSupplierAddEditSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setAddSuppliers({
            ...addSuppliers,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function bindSupplier(value){
        setAddSuppliers(
            {
                ...addSuppliers,
                customerID : value.customerID
            }
        );
    }

    async function checkIsOrderCompleted() {
        var count = 0;

        itemDetails.forEach(o => {
            var totalCombinedVal = 0;
            var currentItemValue = o.itemQuantity;

            supplierItems.forEach(s => {
                if (s.orderItemID === o.orderItemID) {
                    totalCombinedVal = parseFloat(s.supplingQauntity) + parseFloat(totalCombinedVal);
                }
            });

            if (currentItemValue === totalCombinedVal) {
                count = count + 1;
            }
        });

        if (isItemRejected) {
            var res = await generateRemainSupplyQty(orderItemsDetails);

            if (res === 0) {
                setIsOrderCompleted(true);
                return true;
            } else {
                setIsOrderCompleted(false);
                return false;
            }
        }
        else if (count === itemDetails.length && count !== 0 && itemDetails.length !== 0) {
            setIsOrderCompleted(true);
            return true;
        } else {
            setIsOrderCompleted(false);
            return false;
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                props.history.push({ pathname: '/PurchaseAdvice' })
            }, 1500);
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    async function handleAddItem() {
        
        const errorMessages = validate(schema, addSuppliers);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        
        if (errorMessages) return;
               
        var supplierItemsCopy = [...supplierItems];

        if (!addSupplierDateCheck()) {
            return;
        }
        else if (!checkItemLimitExceed(supplierItemsCopy)) {
            return;
        }

        setOpenDialog(false);
        setUserConfirmMessage(true);
        
    }

    async function checkAddUser() {
        var selectedItem = suppliers.filter((x, index) => index === parseInt(addSuppliers.customerID));

        const newSupplierItem = {
            collectionTypeID: selectedRowData.collectionTypeID,
            orderItemID: selectedRowData.orderItemID,
            supplierName: selectedItem[0],
            customerID: parseInt(addSuppliers.customerID),
            supplingQauntity: parseFloat(addSuppliers.quantity),
            unitPrice: parseFloat(roundNumber(addSuppliers.unitPrice)),
            totalPrice: roundNumber((parseFloat(addSuppliers.quantity) * parseFloat(addSuppliers.unitPrice))),
            supplyDate: addSuppliers.supplyDate
        }
        const response = await services.SaveSupplierOrder(newSupplierItem, orderDetails);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });

        var result = await services.getOrderDetailsForSupplierAddScreen(id);
        setScreenData(result);
        setDailogBoxEmpty();

    }

    function addSupplierDateCheck() {
        if (addSuppliers.supplyDate < new Date().toISOString().split('T')[0]) {
            setErrors({
                ...errors,
                supplierItemErrMsg: "Should only add today onwards dates "
            });
            return false;
        }
        else if (addSuppliers.supplyDate > orderDetails.dueDate.split('T')[0]) {
            setErrors({
                ...errors,
                supplierItemErrMsg: "Cannot exceed due date"
            });
            return false;
        }
        else {
            const error = { ...errors }
            delete error["supplierItemErrMsg"]
            setErrors(error);
            return true;
        }
    }

    function supplierAlredyAddedCheck(supplierItemsCopy) {
        var isItemAdded = supplierItemsCopy.filter(f => parseInt(f.customerID) === parseInt(addSuppliers.customerID)
            && f.orderItemID === selectedRowData.orderItemID);

        if (isItemAdded.length > 0) {
            setErrors({
                ...errors,
                supplierItemErrMsg: isItemAdded[0].firstName + " already added"
            });
            return false;
        }
        else {
            const error = { ...errors }
            delete error["supplierItemErrMsg"]
            setErrors(error);
            return true;
        }
    }

    function checkItemLimitExceed(supplierItemsCopy) {
        var checkTotal = 0;
        supplierItemsCopy.forEach(x => {
            if (x.orderItemID === selectedRowData.orderItemID) {
                checkTotal = checkTotal + parseFloat(x.supplingQauntity);
            }
        });

        if (isItemRejected && remainSupplyingQty <= 0) {
            setErrors({
                ...errors,
                supplierItemErrMsg: "Item Quantity Exceeded."
            });
            return false;
        } else if ((checkTotal + parseFloat(addSuppliers.quantity)) > parseFloat(selectedRowData.itemQuantity)) {
            setErrors({
                ...errors,
                supplierItemErrMsg: "Item Quantity Exceeded."
            });
            return false;
        } else {
            const error = { ...errors }
            delete error["supplierItemErrMsg"]
            setErrors(error);
            return true;
        }
    }

    function setDailogBoxEmpty() {
        setAddSuppliers({
            ...addSuppliers,
            customerID: '0',
            quantity: '0',
            unitPrice: '0',
            totalPrice: '0',
            supplyDate: ''
        });
        const error = { ...errors }
        delete error["supplierItemErrMsg"]
        setErrors(error);
    }

    function roundNumber(num) {
        return (Math.round(num * 100) / 100).toFixed(2);
    }

    async function handleItemRemoveClick(itemData) {
        var response = await services.removeSelectedSupplierOrderItem(itemData);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });

        var result = await services.getOrderDetailsForSupplierAddScreen(id);
        setScreenData(result);
    }

    function handleClickOpen(data) {
        var rejectedItemCount = supplierItems.filter(y => (y.orderItemID === data.orderItemID && y.statusTypeID === 7));

        if (rejectedItemCount.length > 0) {
            setMessageModel({ ...messageModel, hidden: false, type: 'Warning', disciption: 'Remove rejected item first.' });
            return;
        }

        var remain = data.itemQuantity;
        var rejectedSuppQty = 0;

        orderItemsViseQty.forEach(x => {
            if (x.orderItemID === data.orderItemID) {
                rejectedSuppQty = rejectedSuppQty + parseFloat(x.supplingQauntity);
            }
        });

        setRemainSupplyingQty(parseFloat(remain) - parseFloat(rejectedSuppQty));

        setDailogBoxEmpty();
        setSelectedRowData(data);
        setOpenDialog(true);
        filterSuppliers(data);
    };

    const handleClose = () => {
        setDailogBoxEmpty();
        setOpenDialog(false);
    };

    const handleConfirmClose = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmOK = () => {
        setOpenConfirmDialog(false);
        trackPromise(handleItemRemoveClick(deleteItemData));
    };

    function createData(orderItemID, collectionTypeName, collectionTypeID, itemQuantity,
        measuringUnit, remQty, supplierItems) {
        return {
            orderItemID,
            collectionTypeName,
            collectionTypeID,
            itemQuantity,
            measuringUnit,
            remQty,
            supplierItems
        };
    }

    async function onEmailSend() {
        var model = {
            orderNo:orderDetails.orderNumber,
            buyerName:orderDetails.buyerName,
            dueDate:new Date().toISOString().split('T')[0],
            groupID:orderDetails.groupID,
            operationEntityID:orderDetails.operationEntityID
        };
        var response = await services.sendEmailNotification(model);
    }

    function Row(props) {
        const { row } = props;
        const [open, setOpen] = React.useState(true);
        const classes = useRowStyles();


        return (
            <React.Fragment>
                <TableRow className={classes.root}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.collectionTypeName}
                    </TableCell>
                    <TableCell align="right">{row.itemQuantity}</TableCell>
                    <TableCell align="right">
                        {
                            row.remQty
                        }
                    </TableCell>
                    <TableCell align="right" component="th" scope="row">
                        {row.measuringUnit === 1 ? "Kg" : "Unit"}
                    </TableCell>
                    <TableCell align="right">
                        <button
                            style={{ width: "40px", height: "40px", backgroundColor: "white", border: "2px solid black", borderColor: "#48B862" }}
                            className="btn"
                            onClick={() => handleClickOpen(row)}>
                            <i className="fas fa-plus" style={{ color: "#48B862" }}></i></button>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: "#FAFAFA" }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {row.supplierItems.length !== 0 ? <Box marginLeft={20}>
                                <Typography variant="body2" gutterBottom component="div">
                                    Supplier Details
                                </Typography>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={subTableHeaders}><b>Supplier</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Quantity</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Unit Price</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Total price (LKR.)</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Last Unit Price</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Status</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Reject Reason</b></TableCell>
                                            <TableCell align="right" style={subTableHeaders}><b>Action</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.supplierItems.map((itemData, i) => {
                                            if (itemData.orderItemID === row.orderItemID) {
                                                return (
                                                    <TableRow key={i} style={(itemData.statusType === 7 || itemData.statusType === 9) ? { backgroundColor: "#FFEBEE" } : null}>
                                                        <TableCell component="th" scope="row"> {itemData.supplierName} </TableCell>
                                                        <TableCell align="right">{itemData.supplingQauntity}</TableCell>
                                                        <TableCell align="right">{roundNumber(itemData.unitPrice)}</TableCell>
                                                        <TableCell align="right">{roundNumber(itemData.totalPrice)}</TableCell>
                                                        <TableCell align="right">{roundNumber(itemData.lastUnitPrice)}</TableCell>
                                                        <TableCell align="right">
                                                            {
                                                                generateStatus(itemData.statusType)
                                                            }
                                                        </TableCell>
                                                        <TableCell align="right">{itemData.rejectReason}</TableCell>
                                                        <TableCell align="right">
                                                            {(itemData.statusType !== 3 && itemData.statusType !== 12 && itemData.statusType !== 13) ?
                                                                <i
                                                                    style={{ cursor: "pointer" }}
                                                                    className="fas fa-trash-alt"
                                                                    onClick={() => {
                                                                        setOpenConfirmDialog(true);
                                                                        setDeleteItemData(itemData);
                                                                    }}
                                                                />
                                                                : null}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        })}
                                    </TableBody>
                                </Table>
                            </Box> : <p style={{ fontSize: "14px" }}>Add suppliers to display here.</p>}
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/PurchaseAdvice"
                        />
                        <hr />
                        <form>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col"><p style={{ fontSize: "14px" }}>
                                        <b>Order Number: </b> {orderDetails.orderNumber}</p>
                                    </div>
                                    <div className="col"><p style={{ fontSize: "14px", textAlign: "center" }}>
                                        <b>Date: </b>{new Date().toISOString().split('T')[0]}</p>
                                    </div>
                                    <div className="col"><p style={{ fontSize: "14px", float: "right" }}>
                                        <b>Buyer: </b>{orderDetails.buyerName}</p>
                                    </div>
                                </div>
                                {orderDetails.statusTypeID === 4 ? <div>
                                    <div class="card pt-2 text-white bg-danger mb-3" style={{ width: "18rem" }}>
                                        <div class="card-header">
                                            Order Rejected.
                                        </div>
                                        <div class="card-body">
                                            Reason Details :{orderDetails.narration}
                                        </div>
                                    </div>
                                </div> : null}
                                <Dialog open={openConfirmDialog} onClose={handleConfirmClose}
                                    aria-labelledby="form-dialog-title">
                                    <DialogTitle id="form-dialog-title">Do you want to delete?</DialogTitle>
                                    <DialogActions>
                                        <Button onClick={handleConfirmClose} color="primary">
                                            Cancel
                                        </Button>
                                        <Button onClick={handleConfirmOK} color="secondary">
                                            Confirm
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <Dialog open={openDialog} onClose={handleClose}
                                    aria-labelledby="form-dialog-title">
                                    <DialogTitle id="form-dialog-title"> Add Suppliers</DialogTitle>
                                    <div className="pl-4">Due Date: <b>{orderDetails.dueDate !== undefined ? orderDetails.dueDate.split('T')[0] : ""}</b></div>
                                    <div className="pl-4">Remain Count: <b>{selectedRowData.remQty}</b></div>
                                    <DialogContent>
                                        <div className="form-group row">
                                            <div className="col-md">
                                            <Autocomplete
                                                        id="customerID"
                                                        name="customerID"
                                                        options={filterSupplier}
                                                        getOptionLabel={(option) => option.firstName+ " - "+ option.customerCode}
                                                        onChange={(e, value) => bindSupplier(value)}
                                                        renderInput={(params) => <TextField {...params}  label="Supplier *" variant="outlined" size="small" />}
                                                    />
                                                {errors["customerID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["customerID"]}</FormHelperText>}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md pt-2">
                                                <TextField fullWidth label="Quntaity *"
                                                    name="quantity"
                                                    id="quantity"
                                                    value={addSuppliers.quantity}
                                                    type="number"
                                                    onChange={(e) => handleChange(e)}
                                                />
                                                {errors["quantity"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["quantity"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pt-2">
                                                <TextField fullWidth label="Unit Price *"
                                                    name="unitPrice"
                                                    id="unitPrice"
                                                    value={addSuppliers.unitPrice}
                                                    type="number"
                                                    onChange={(e) => handleChange(e)}
                                                />
                                                {errors["unitPrice"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["unitPrice"]}</FormHelperText>}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md pt-2">
                                                <InputLabel shrink id="supplyDate">Supply Date *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="supplyDate"
                                                    name="supplyDate"
                                                    type="date"
                                                    onChange={(e) => handleChange(e)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                                {errors["supplyDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["supplyDate"]}</FormHelperText>}
                                            </div>
                                        </div>
                                        <div className="card-title pt-2"><p style={{ fontSize: "18px" }}>Total Price: {roundNumber((parseFloat(addSuppliers.unitPrice) * parseFloat(addSuppliers.quantity)))}</p></div>
                                        {errors["supplierItemErrMsg"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["supplierItemErrMsg"]}</FormHelperText>}
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose} color="primary">
                                            Cancel
                                        </Button>
                                        <Button onClick={handleUserAdd} color="primary">
                                            Add
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <div className="row">
                                    <div className="col">
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table">
                                                <TableHead style={{ backgroundColor: "White" }}>
                                                    <TableRow>
                                                        <TableCell />
                                                        <TableCell style={tableHeaderStyle}>Item Name</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Remaining Quantity</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Measuring Unit</TableCell>
                                                        <TableCell align="right" style={tableHeaderStyle}>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {itemDetails.map((row, i) => { 
                                                        return (
                                                            <Row key={i} row={row} />
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className="form-group row">
                        <div className="col">
                                        
                                    </div>
                                    <div className="col">
                                       
                                    </div>
                                    <div className="col">
                                    <input
                                    type="button"
                                    onClick={handleEmail}
                                    className="btn btn-primary pull-right"
                                    value="Notify Via Email"
                                />
                            
                                    </div>
                            
                           
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
            {/* popUP Start */}
            <div hidden={true}>
            <Paper variant="outlined" square>
          
            
            <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                discription={"Are You Want to Send Email? "} setViewPopup={setEnableConfirmMessage} />
                 </Paper>
                 
                  </div>
           <div hidden={true}>
            <Paper variant="outlined" square>
                
                
            <AlertDialog confirmData={confirmUserData} headerMessage={usermessage} viewPopup={UserConfirmMessage}
                discription={"Are You Want to Add User "} setViewPopup={setUserConfirmMessage} />
                

            </Paper>
            </div>
              
            {/* popup end */}
        </Fragment >
    );
}
